<template>
  <div class="same_question_entry_explain" @click="toSame">
    <div class="flex-row flex-al-center flex-jc-bt">
      <div class="flex-row flex-al-center">
        <div class="entry_img">
          <img
            src="https://img01.yzcdn.cn/upload_files/2021/09/14/FilzRg1rQM8F5F2Y7c3Dm4BMn4cC.png"
          />
        </div>
        <div class="entry_text flex-col">
          <span class="entry_text_h">举一反三</span>
          <span class="entry_text_s">本题的同类题目推荐</span>
        </div>
      </div>
      <div class="entry_btn flex-center">立刻去练习</div>
    </div>
  </div>
</template>

<script>
/*
 * By Suxue
 * 2021/9/13
 */
import { checkIsHasSameQuestion } from '@/pages/answer/route/sameQuestion/function'
import { isNoneVip } from '@/ProductAuthority/SKU'

export default {
  name: 'Index',
  data() {
    return {}
  },
  mounted() {},
  methods: {
    toSame() {
      const { workbookId, questionId } = this.$route.query
      checkIsHasSameQuestion({
        questionId,
        success: () => {
          this.$trackevent({
            type: 'funcTracker',
            action: 'click',
            opt_label: `举一反三-讲解页-${
              isNoneVip(this.$store.state.user.userInfo) ? '非会员' : '会员'
            }`
          })
          this.$router.push({
            path: '/sameQuestion',
            query: {
              bookId: workbookId,
              questionId: questionId
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.same_question_entry_explain {
  margin: 16px;
  padding: 7px 12px 6px 5px;
  height: 79.97px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  .entry_img {
    img {
      width: 50px;
      height: 67px;
    }
  }
  .entry_text {
    margin-left: 10px;
    .entry_text_h {
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 5px;
    }
    .entry_text_s {
      font-size: 13px;
      line-height: 18px;
      color: #716f70;
    }
  }
  .entry_btn {
    margin-top: 7px;
    width: 80px;
    height: 26px;
    background: linear-gradient(270deg, #ff380d 0%, #ff7236 100%);
    border-radius: 50px;
    font-size: 13px;
    color: #ffffff;
  }
}
</style>
